import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function useLanguage() {
  const { locale, t } = useI18n()

  const updateTitle = () => {
    document.title = t('meta.title')
  }

  const currentLocale = computed(() => 'ar')

  const isRTL = computed(() => true)

  // Initialize on first load - always Arabic
  const initializeLanguage = () => {
    locale.value = 'ar'
    document.documentElement.dir = 'rtl'
    document.documentElement.lang = 'ar'
    updateTitle()
  }

  return {
    locale: currentLocale,
    isRTL,
    initializeLanguage,
    t
  }
}
